import { c as _c } from "react/compiler-runtime";
import { formatClaimStatus, formatEditionSize } from "@/helpers/manifoldDisplayHelpers";
import { useMemesManifoldClaim } from "@/hooks/useManifoldClaim";
import NowMintingStatsItem from "./NowMintingStatsItem";
interface NowMintingStatsGridProps {
  readonly nftId: number;
  readonly floorPrice: string;
}
export default function NowMintingStatsGrid(t0) {
  const $ = _c(17);
  const {
    nftId,
    floorPrice
  } = t0;
  const manifoldClaim = useMemesManifoldClaim(nftId);
  const status = manifoldClaim?.status;
  const isStatusLoading = !manifoldClaim;
  let t1;
  if ($[0] !== manifoldClaim) {
    t1 = manifoldClaim ? formatClaimStatus(manifoldClaim) : undefined;
    $[0] = manifoldClaim;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const statusLabel = t1;
  const statusTone = manifoldClaim?.isFinalized ? "ended" : status;
  let t2;
  if ($[2] !== manifoldClaim) {
    t2 = manifoldClaim ? formatEditionSize(manifoldClaim) : undefined;
    $[2] = manifoldClaim;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const editionSize = t2;
  let t3;
  if ($[4] !== editionSize) {
    t3 = <NowMintingStatsItem label="Edition" value={editionSize} />;
    $[4] = editionSize;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== isStatusLoading || $[7] !== statusLabel || $[8] !== statusTone) {
    t4 = <NowMintingStatsItem label="Status" value={statusLabel} status={statusTone} isLoading={isStatusLoading} />;
    $[6] = isStatusLoading;
    $[7] = statusLabel;
    $[8] = statusTone;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <NowMintingStatsItem label="Mint price" value="0.06529" />;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== floorPrice) {
    t6 = <NowMintingStatsItem label="Floor" value={floorPrice} />;
    $[11] = floorPrice;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t3 || $[14] !== t4 || $[15] !== t6) {
    t7 = <div className="tw-grid tw-grid-cols-2 tw-gap-x-8 tw-gap-y-4 tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-iron-800 tw-pt-5">{t3}{t4}{t5}{t6}</div>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}